"use client";

import { useRef } from "react";
import Link from "next/link";

import { normalizeTnsName } from "@coinbot/forge-api/external";
import { ForgeTNS } from "@coinbot/forge-api/models";

import { ListingRowItem } from "~/components/common/ListingRowItem";
import { SearchInput } from "../../../common/SearchInput";
import { Dialog, DialogContent, DialogTrigger, FormField } from "../../../ui";
import { useNavbarSearch } from "../useNavbarSearch";

export function NavbarDesktopSearch() {
  const { isPopoverOpen, setIsPopoverOpen, onSubmit, tnsItems, isFetched, isFetching, isEmpty } =
    useNavbarSearch();
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  const triggerBoundingRect = triggerRef?.current?.getBoundingClientRect();

  const top = (triggerBoundingRect?.top || 0) + (triggerBoundingRect?.height || 0);
  const left = triggerBoundingRect?.left || 0;
  const right = triggerBoundingRect?.right || 0;
  const width = triggerBoundingRect?.width || 0;

  return (
    <Dialog open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <FormField
        name="search"
        render={({ field }) => {
          return (
            <DialogTrigger
              ref={triggerRef}
              onClick={(e) => e.stopPropagation()}
              className="mx-auto flex w-full max-w-[500px] items-center px-2"
              asChild
            >
              <form onSubmit={onSubmit} className="w-full">
                <SearchInput
                  ref={field.ref}
                  className="relative"
                  onFocus={() => setIsPopoverOpen(true)}
                  onBlur={() => setIsPopoverOpen(false)}
                  onChange={(e) => field.onChange(normalizeTnsName(e.target.value))}
                  value={normalizeTnsName(field?.value)}
                  isLoading={isPopoverOpen && isFetching}
                />
              </form>
            </DialogTrigger>
          );
        }}
      />

      <DialogContent
        close={false}
        onOpenAutoFocus={(e) => e.preventDefault()}
        style={{ backgroundColor: "black", top, left, right, width }}
        className="mt-4 flex min-w-0 !max-w-full !translate-x-0 !translate-y-0 flex-col gap-2 rounded-xs border-0 bg-button-gradient-2 px-1 py-1"
      >
        {tnsItems?.map((tns: ForgeTNS) => {
          return (
            <Link
              href={
                tns?.type === "unregistered_thorname"
                  ? `/register?tns=${encodeURIComponent(normalizeTnsName(tns?.name))}`
                  : `/tns/${normalizeTnsName(tns?.name)}`
              }
              key={`popover-tcr-item-${tns?.id}-${tns?.name}`}
              className="flex rounded-xs bg-black/15 px-2 transition-colors duration-200 hover:bg-black/40"
            >
              <ListingRowItem tns={tns} />
            </Link>
          );
        })}

        {isFetched ? (
          isEmpty && <div className="py-2 text-center text-lg font-medium">No results found</div>
        ) : (
          <div className="py-2 text-center text-lg font-medium">Searching THORNames...</div>
        )}

        {/* <div className="mt-5 border-b border-white pb-1 text-sm uppercase">Category Name</div>

          <TopCategoryRowItem category={suggestedThornames[0]} />
          <TopCategoryRowItem category={suggestedThornames[0]} /> */}
      </DialogContent>
    </Dialog>
  );
}
